<template>
    <div class="page">
        <PageTitle :title="title" :routes="routes"></PageTitle>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import PageTitle from '@/components/PageTitle'

    export default {
        name: 'Lottery',
        components: {
            PageTitle
        },
        computed: {
            title() {
                let name = '抽奖列表'
                if (this.routes.length > 0) name = this.routes[this.routes.length - 1].name
                return name
            },
            ...mapState({
                routes: 'route'
            })
        },
        mounted() {
            // let path = this.$route.path
            // if (path.indexOf('/') === 0) path = path.substring(1)
            // const id = this.$route.query.id * 1 || null
            // const currentPage = {
            //   link: path,
            //   name: '品牌列表'
            // }
            // if (id) currentPage.name = '编辑品牌信息'
            // this.$store.commit('changeRoute', currentPage)
        },
        beforeDestroy() {
            this.$store.commit('changeRoute', null)
        },
        beforeRouteUpdate(to, from, next) {
            let path = to.path
            if (path.indexOf('/') === 0) path = path.substring(1)
            const name = to.query.id ? 'LotteryDetail' : to.name
            const chineseName = {
                LotteryDetail: '编辑抽奖',
                LotteryAdd: '发起抽奖'
            }
            const toPage = {
                link: path,
                name: chineseName[name]
            }
            this.$store.commit('changeRoute', toPage)
            next()
        }
    }
</script>
